import wbsBookingsApi from '../apis/wbsBookingsApi';

interface IDeleteSpotsProps {
  isVerified?: boolean;
  spotId: string;
}

const deleteSpotsService = async ({
  isVerified,
  spotId,
}: IDeleteSpotsProps): Promise<void> => {
  await wbsBookingsApi.delete(`/spots/${spotId}`, { params: { isVerified } });
};

export default deleteSpotsService;
